<template>

    
    <modal 
        :title="$t('invoic')" 
        :ifPrevopen="ifPrevopen" 
        :ifNextopen="ifNextopen" 
        @prevOpen="prevOpen" 
        @nextOpen="nextOpen" 
        :key="componentKey"
        :stylebody="'var(--vz-body-bg)'" 
        @close="this.$emit('close')"
    >
        <template v-slot:head-bottom>
            <button type="button" class="btn btn-soft-danger btn-icon btn-sm fs-16 close-btn-email"  @click="$emit('close')"><i class="ri-close-fill align-bottom"></i></button>
        </template>
        <template v-slot:body>
            <div class="row justify-content-center">
            <div class="col-xxl-9">
                <div class="card" id="demo">
                    <div class="card-header border-bottom-dashed p-4">
                        <div class="d-sm-flex">
                            <div class="flex-grow-1">
                                    <img src="https://skyservice.pro/templates/img/logo.svg" class="card-logo card-logo-dark" alt="logo dark" style="width: 200px;">
                                    <img src="https://skyservice.pro/templates/img/logo.svg" class="card-logo card-logo-light" alt="logo light" style="width: 200px;">
                            </div>
                        </div>
                    </div><!--end card-header-->
                    <div class="card-body p-4" >
                        <div class="row g-3">
                            <div class="col-lg-2 col-6">
                                <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('invoic') }}</p>
                                <h5 class="fs-14 mb-0" v-if="form.date >= '2023-11-28'"># {{ form.num.id }}</h5>
                                <h5 class="fs-14 mb-0" v-else># {{ this.form.provider == 'TOV' ? this.form.numTOV.id : this.form.numFOP.id }}</h5>
                            </div><!--end col-->
                            <div class="col-lg-2 col-6">
                                <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('date') }}</p>
                                <h5 class="fs-14 mb-0">{{ this.form.datetime }}</h5>
                            </div><!--end col-->
                            <div class="col-lg-2 col-6">
                                <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('clients_number') }}</p>
                                <span :class="'fs-12 fw-semibold'">{{ form.sellerPhone }}</span>
                            </div>
                            <div class="col-lg-3 col-6">
                                <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('PaymentStatus') }}</p>
                                <span :class="'badge ' + this.mutatestatus(this.form.payment.status).color + ' fs-11'">{{this.mutatestatus(this.form.payment.status).name}}</span>
                            </div>
                            <!--end col-->
                            <div class="col-lg-3 col-6">
                                <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('Total') }}</p>
                                <h5 class="fs-14 mb-0">₴ {{ this.form.sum.toFixed(2) }}</h5>
                            </div><!--end col-->
                        </div><!--end row-->
                    </div><!--end card-body-->
                    <div class="card-body p-4 border-top border-top-dashed">
                        <b-row>
                            <b-col lg="2">
                                <h4 class="fs-15">{{ $t('Provider') }}</h4>
                            </b-col>
                            <b-col lg="10">
                                <template v-if="form.date >= '2023-11-28'">
                                    <label v-if="provider.businessEntity == 'TOV' && (provider.workWithPDV === true || provider.workWithPDV === 'true')">
                                        <b>{{ provider.providerTitle }}</b> 
                                        <br />IBAN: {{ provider.iban }} в {{ provider.bank }}, {{ provider.address }} 
                                        <br />Тел. {{ provider.phone }} 
                                        <br />Код ЄДРПОУ {{ provider.erdpu }}, ІПН {{ provider.ipn }} 
                                    </label>
                                    <label v-if="(provider.businessEntity == 'FOP' || provider.businessEntity == 'TOV') && (provider.workWithPDV == false || provider.workWithPDV == 'false')">
                                        <b>{{ provider.providerTitle }}</b> 
                                        <br />Р/р {{ provider.iban }}, {{ provider.bank }}, МФО {{ provider.mfo }} код по ЄРДПОУ {{ provider.erdpu }}
                                    </label>
                                </template>
                                <template v-else>
                                    <label v-if="form.provider == 'TOV' || form.provider == 'tov'">
                                        <b>{{ settingInv.TOV.provider }}</b> 
                                        <br />IBAN: {{ settingInv.TOV.iban }} в {{ settingInv.TOV.bank }}, {{ settingInv.TOV.address }} 
                                        <br />Тел. {{ settingInv.TOV.phone }} 
                                        <br />Код ЄДРПОУ {{ settingInv.TOV.erdpu }}, ІПН {{ settingInv.TOV.ipn }} 
                                    </label>
                                    <label v-if="form.provider == 'FOP' || form.provider == 'fop' ">
                                        <b>{{ settingInv.FOP.provider }}</b> 
                                        <br />Р/р {{ settingInv.FOP.calculatedWallet }}, {{ settingInv.FOP.bank }}, МФО {{ settingInv.FOP.mfi }} код по ЄРДПОУ {{ settingInv.FOP.erdpu }}
                                    </label>
                                </template>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col lg="2">
                                <h4 class="fs-15">{{ $t('Buyer') }}</h4>
                            </b-col>
                            <b-col lg="10">
                                <label >
                                    <b>{{form.sellerName}} </b> 
                                    <br /><span v-if="form.descbuyer != ''">{{form.economicalSociety}}</span>
                                </label>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col lg="2">
                                <h4 class="fs-15">{{ $t('Treaty') }}</h4>
                            </b-col>
                            <b-col lg="10">
                                <label >
                                    {{$t('invoic')}}
                                    <b></b> 
                                </label>
                            </b-col>
                        </b-row>
                    </div><!--end card-body-->
                    <div class="card-body p-4">
                        <div class="table-responsive">
                            <table class="table table-borderless text-center table-nowrap align-middle mb-0">
                                <thead>
                                    <tr class="table-active">
                                        <th scope="col" style="width: 50px;">№</th>
                                        <th scope="col">{{ $t('Goods') }}</th>
                                        <th scope="col">{{ $t('Quantity') }}</th>
                                        <th scope="col">{{ $t('unit') }}</th>
                                        
                                        <template v-if="form.date >= '2023-11-28'">
                                            <th scope="col">{{ provider.businessEntity == 'TOV' && provider.workWithPDV == 'true' ? 'Ціна без ПДВ' : 'Ціна' }}</th>
                                            <th scope="col">{{ provider.businessEntity == 'TOV' && provider.workWithPDV == 'true' ? 'Сума без ПДВ' : 'Сума'}}</th>
                                            <th scope="col" v-if="provider.businessEntity == 'TOV' && provider.workWithPDV == 'true'">Сума ПДВ:</th>
                                        </template>
                                        <template v-else>
                                            <th scope="col">{{ form.provider == 'TOV' ? $t('PriceWithoutVAT') : $t('priceprod')  }}</th>
                                            <th scope="col">{{ form.provider == 'TOV' ? $t('AmountWithoutVAT') : $t('Sum') }}</th>
                                            <th scope="col" v-if="form.provider == 'TOV'" class="text-end" >{{ $t('VATamount') }}</th>
                                        </template>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in this.form.products" :key="index">
                                        <th scope="row">{{index+1}}</th>
                                        <td class="text-start">
                                            <span class="fw-medium">{{item.nomenclatureName}}</span>
                                        </td>
                                        <td>{{item.quantity}}</td>
                                        <td>шт.</td>
                                        <td>{{String((item.priceWithoutVAT).toFixed(2))}}</td>
                                        <td>{{ String((item.priceWithoutVAT * item.quantity).toFixed(2)) }}</td>
                                       
                                        <template v-if="form.date >= '2023-11-28'">
                                            <td class="text-end" v-if="provider.businessEntity == 'TOV' && provider.workWithPDV == 'true'">{{ item.VATsum }}</td>
                                        </template>
                                        <template v-else>
                                            <td class="text-end" v-if="form.provider == 'TOV'">{{ item.VATsum }}</td>
                                        </template>
                                    </tr>
                                    
                                    <tr class="border-top border-top-dashed mt-2">
                                        <td colspan="5"></td>
                                        <td colspan="2" class="fw-medium p-0">
                                            <table class="table table-borderless text-start table-nowrap align-middle mb-0">
                                                <tbody>

                                                    <template v-if="form.date >= '2023-11-28'">
                                                        <tr v-if="provider.businessEntity == 'TOV' && provider.workWithPDV == 'true'">
                                                            <td><b>{{ $t('TotalwithoutVAT') }}</b></td>
                                                            <td class="text-end">{{String((Number(form.sum)).toFixed(2))}}</td>
                                                        </tr>
                                                        <tr v-if="provider.businessEntity == 'TOV' && provider.workWithPDV == 'true'">
                                                            <td><b>{{ $t('TotalVat') }}</b></td>
                                                            <td class="text-end">{{String((Number(form.sum) * 0.2).toFixed(2))}}</td>
                                                        </tr>
                                                    </template>
                                                    <template v-else>
                                                        <tr v-if="form.provider == 'TOV'">
                                                            <td><b>{{ $t('TotalwithoutVAT') }}</b></td>
                                                            <td class="text-end">{{String((Number(form.sum)).toFixed(2))}}</td>
                                                        </tr>
                                                        <tr v-if="form.provider == 'TOV'">
                                                            <td><b>{{ $t('TotalVat') }}</b></td>
                                                            <td class="text-end">{{String((Number(form.sum) * 0.2).toFixed(2))}}</td>
                                                        </tr>
                                                    </template>

                                                    <!-- <tr v-if="form.provider == 'TOV'">
                                                        <td><b>{{ $t('TotalwithoutVAT') }}</b></td>
                                                        <td class="text-end">{{(Number(form.sum)).toFixed(2)}}</td>
                                                    </tr> -->
                                                    <!-- <tr v-if="form.provider == 'TOV'">
                                                        <td><b>{{ $t('TotalVat') }}</b></td>
                                                        <td class="text-end">{{(Number(form.sum) * 0.2).toFixed(2)}}</td>
                                                    </tr> -->
                                                    <!-- <tr>
                                                        <td><b>{{ form.provider == 'TOV' ? $t('TotalIncludingVAT') : $t('Total')  }}</b></td>
                                                        <td v-if="form.provider == 'TOV'" class="text-end">{{(form.sum+form.sum*0.2).toFixed(2)}}</td>
                                                        <td v-else class="text-end">{{(form.sum).toFixed(2)}}</td>
                                                    </tr> -->
                                                    <template v-if="form.date >= '2023-11-28'">
                                                        <td><b>{{ provider.businessEntity == 'TOV' && provider.workWithPDV == 'true' ? $t('TotalIncludingVAT') : $t('Total')  }}</b></td>
                                                        <td v-if="provider.businessEntity == 'TOV' && provider.workWithPDV == 'true'" class="text-end">{{String((form.sum+form.sum*0.2).toFixed(2))}}</td>
                                                        <td v-else class="text-end">{{(form.sum).toFixed(2)}}</td>
                                                    </template>
                                                    <template v-else>
                                                        <td><b>{{ form.provider == 'TOV' ? $t('TotalIncludingVAT') : $t('Total')  }}</b></td>
                                                        <td v-if="form.provider == 'TOV'" class="text-end">{{String((form.sum+form.sum*0.2).toFixed(2))}}</td>
                                                        <td v-else class="text-end">{{String((form.sum).toFixed(2))}}</td>
                                                    </template>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                        <div class="hstack gap-2 justify-content-start d-print-none mt-4">
                            <h5 style="font-weight: 700;">{{ this.$t('Comment') }}: <span style="font-weight: initial;">{{ this.form.comment }}</span></h5>
                        </div>

                        <!-- Готовий текст листа клієнту (номер акаунту, назва компанії, № і дата рахунку підставляються з рахунку) -->
                        <div class="d-print-none mt-4">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <h5 class="fs-15 mb-0">{{ $t('invoiceEmailText') }}</h5>
                                <button type="button" class="btn btn-soft-primary btn-sm" @click="copyEmailText">
                                    <i class="ri-file-copy-line align-bottom me-1"></i> {{ $t('invoiceEmailCopy') }}
                                </button>
                            </div>
                            <textarea class="form-control" rows="5" readonly :value="emailText"></textarea>
                        </div>
                        
                    </div>

                    <!-- Коментар до платежу, коментар підтвердження або анулювання -->
                    <div class="p-4 border-top border-top-dashed" v-if="(form.status == 'confirmed' && form.confirmedComment != '' || form.status == 'canceled' && form.cancelComment != '') && form.status != 'new'">
                        <h5 class="fw-semibold text-muted">{{ $t('CommentThePayment') }}</h5> 
                        <span>{{ (form.status == 'confirmed' || form.status == 'canceled') && form.status != 'new' ? this.form.confirmedComment : this.form.cancelComment }}</span>
                    </div>
                </div>
            </div>
        </div>
        <toPrint :obj="this.form"/>
        <toExInvPrint :obj="this.form" />

        </template>
        <template v-slot:footer-bottom>
            <a class="btn btn-link link-success fw-medium" data-bs-dismiss="modal" @click="exportToPDF"><i class="ri-close-line me-1 align-middle"></i> {{ $t('close') }} </a>
            <button 
                class="btn btn-danger"
                @click="dialogShow = true"
            >
                {{ $t('Delete')}}
            </button>
            <button 
                class="btn btn-warning" 
                v-if="
                    (
                        form.payment.status == 'pendingpay' &&
                        this.perms[1702]==true
                    ) ||
                    (this.userid === 46)
                " 
                @click="this.$emit('edit', this.form)"
            >
                <i class="ri-pencil-fill align-bottom me-1"></i> {{$t('Edit')}}
            </button>
            <!-- оверлей для закриття відкритого дропдауна по кліку повз -->
            <div v-if="openDoc" @click="openDoc = null" style="position:fixed;inset:0;z-index:1090;"></div>

            <!-- Рахунок: завантажити / надіслати / підписати -->
            <div class="btn-group" style="position:relative;">
                <button type="button" class="btn btn-warning dropdown-toggle" @click="toggleDoc('invoice')">
                    <i class="bx bxs-file-pdf me-1 fs-16"></i> {{ $t('eobigInvoiceWord') }}
                </button>
                <div v-if="openDoc === 'invoice'" class="dropdown-menu show" style="display:block;position:absolute;bottom:100%;left:0;z-index:1100;min-width:230px;">
                    <button class="dropdown-item" @click="docAction('invoice','download')"><i class="bx bx-download me-2"></i>{{ $t('DownloadAccount') }}</button>
                    <template v-if="(this.perms[1705] || this.perms[1700] || this.perms[2000]) && this.form.documentId">
                        <button class="dropdown-item" @click="docAction('invoice','send')"><i class="bx bxs-send me-2"></i>{{ $t('eobigSendForSign') }}</button>
                        <button class="dropdown-item" @click="docAction('invoice','signsend')"><i class="bx bxs-pen me-2"></i>{{ $t('eobigSignAndSend') }}</button>
                    </template>
                </div>
            </div>

            <!-- Накладна (лише для оплаченого рахунку) -->
            <div v-if="form.payment.status == 'paid'" class="btn-group" style="position:relative;">
                <button type="button" class="btn btn-warning dropdown-toggle" @click="toggleDoc('waybill')">
                    <i class="bx bxs-file-pdf me-1 fs-16"></i> {{ $t('eobigWaybill') }}
                </button>
                <div v-if="openDoc === 'waybill'" class="dropdown-menu show" style="display:block;position:absolute;bottom:100%;left:0;z-index:1100;min-width:230px;">
                    <button class="dropdown-item" @click="docAction('waybill','download')"><i class="bx bx-download me-2"></i>{{ $t('DownloadtheInvoice') }}</button>
                    <template v-if="(this.perms[1705] || this.perms[1700] || this.perms[2000]) && this.form.documentId">
                        <button class="dropdown-item" @click="docAction('waybill','send')"><i class="bx bxs-send me-2"></i>{{ $t('eobigSendForSign') }}</button>
                        <button class="dropdown-item" @click="docAction('waybill','signsend')"><i class="bx bxs-pen me-2"></i>{{ $t('eobigSignAndSend') }}</button>
                    </template>
                </div>
            </div>

            <span v-if="eobigBadge()" :class="`badge ${eobigBadge().cls} align-middle ms-1`">{{ eobigBadge().label }}</span>
            <button
                type="button"
                @click="showAnnulBox = true"
                class="btn btn-danger r waves-effect waves-light">
                {{ $t('cancel') }}
            </button>
            <button 
                type="button"
                v-if="checkButtonVisible()"
                @click="showConfirmBox = true"
                :class="`btn btn-success ss waves-effect waves-light`">
                {{ $t('Confirm') }}
            </button>
            <button 
                type="button"
                v-if="form.payment.status == 'annul'"
                @click="Ах(form)" key=""
                :class="`btn btn-primary ss waves-effect waves-light`">
                {{ $t('Copy') }}
            </button>
            <!-- <a class="btn btn-primary"><i class="ri-download-2-line align-bottom me-1"></i> {{$t('Download')}}</a> -->

            <!-- <button @click="exportToPDFNew">Експорт в PDF</button> -->
       </template>
    </modal>
    
    <editmodal v-if="editmodal == true" @close="editmodal = false" :editform="this.form" />

    <modalremove v-if="dialogShow" @close="dialogShow = false" @remove="remove" />

    <!-- Модальне вікно підтвердження рахунку -->
    <confirmBox 
        v-if="showConfirmBox"
        @close="closeConfirmBlock"
        :obj="this.form"
    />

    <!-- Модальне вікно анулювання рахунку -->
    <annulBox
        v-if="showAnnulBox"
        @close="showAnnulBox = false;this.updateCard()"
        :obj="this.form"
    />

    <!-- eObig: ввід пошти клієнта -->
    <div
        v-if="eobigModalShow"
        @click.self="eobigModalShow = false"
        style="position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:2000;display:flex;align-items:center;justify-content:center;"
    >
        <div class="card mb-0" style="max-width:460px;width:92%;">
            <div class="card-body">
                <h5 class="mb-1">{{ eobigMode === 'signsend' ? $t('eobigSignAndSend') : $t('eobigSendForSign') }}</h5>
                <p class="text-muted fs-13 mb-3">{{ eobigDocType === 'waybill' ? $t('eobigWaybill') : $t('eobigInvoiceWord') }} · eObig</p>
                <p class="text-muted mb-2 fs-14 fw-semibold">{{ $t('eobigClientEmail') }}</p>
                <input type="email" class="form-control mb-3" v-model="eobigEmail" placeholder="client@example.com" />
                <p class="text-muted mb-2 fs-14 fw-semibold">{{ $t('Comment') || 'Коментар' }}</p>
                <textarea class="form-control mb-3" rows="2" v-model="eobigComment"></textarea>
                <div class="d-flex justify-content-end gap-2">
                    <button class="btn btn-light" @click="eobigModalShow = false">{{ $t('close') }}</button>
                    <button class="btn btn-primary" :disabled="eobigSending" @click="submitEobig()">
                        <span v-if="eobigSending" class="spinner-border spinner-border-sm me-1"></span>
                        {{ eobigMode === 'signsend' ? $t('eobigSign') : $t('Send') }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- eObig: модалка підпису (віджет eObig в iframe) -->
    <div
        v-if="signModalShow"
        style="position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:2050;display:flex;align-items:center;justify-content:center;"
    >
        <div class="card mb-0" style="width:92%;max-width:900px;height:88vh;display:flex;flex-direction:column;">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0">{{ $t('eobigSignTitle') }}</h5>
                <div class="d-flex gap-2">
                    <a :href="signUrl" target="_blank" rel="noopener" class="btn btn-sm btn-light">{{ $t('eobigOpenNewTab') }}</a>
                    <button class="btn btn-sm btn-success" @click="closeSignModal()">{{ $t('eobigDone') }}</button>
                </div>
            </div>
            <div class="card-body p-0" style="flex:1;overflow:hidden;">
                <iframe :src="signUrl" style="width:100%;height:100%;border:0;" title="eObig sign"></iframe>
            </div>
            <div class="card-footer text-muted fs-13">
                {{ $t('eobigSignHint') }}
            </div>
        </div>
    </div>

</template>

<script>

// import animationData from "@/components/widgets/kbtmbyzy.json";
import toPrint from './toPrint'
import toExInvPrint from './toExpendInv'
import modal from '@/components/modal'
import editmodal from '@/views/invoices/createinvoices'
import modalremove from '@/components/modal/modalremove'
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import confirmBox from './actions/confirm.vue' // Модальне вікно підтвердження рахунку
import annulBox from './actions/annul.vue' // Модальне вікно скасування рахунку
import { Invoices } from '@/API.js';
import { try_SendInvoice, try_SendWaybill, try_SignAndSend, try_GetDocStatus } from '@/api/services/eobig' // eObig (ЕДО)
import eobigStatusHelpers from '@/api/services/eobigStatus' // мапінг статусу eObig -> бейдж
import { storeS } from '@/store.js'
import { mutateStatusInv } from '@/usabilityScripts/globalMutate.js'
import axios from "axios";

let apiServe = new Invoices();

export default {
    data() {
        return {   
            data: "",
            print_check: false,
            editmodal: false,
            form: {
                status:"",
            },
            printInv: false,
            printSalInv: false,
            status: [
                { value: 'pendingpay', label: this.$t('pendingpay') },
                { value: 'paidpay', label: this.$t('paidpay') },
                { value: 'annul', label: this.$t('annul') },
            ],
            provider: "",
            dialogShow: false,
            showConfirmBox: false,
            showAnnulBox: false,
            componentKey: '',
            token: '',
            companyId: '',
            // eObig (ЕДО)
            openDoc: null,          // який дропдаун відкрито: 'invoice' | 'waybill' | null
            eobigModalShow: false,  // модалка вводу email
            eobigMode: '',          // 'send' | 'signsend'
            eobigDocType: '',       // 'invoice' | 'waybill'
            eobigEmail: '',
            eobigComment: '',
            eobigSending: false,
            eobigStatusOverride: '',
            signModalShow: false,   // модалка підпису (iframe eObig)
            signUrl: ''
        };
    },
    props: ["obj", 'ifPrevopen', 'ifNextopen'],
    components: {
        modal,
        Multiselect,
        toPrint,
        toExInvPrint,
        editmodal,
        modalremove,
        confirmBox,
        annulBox
    },
    created() {
        this.getData();
        this.getDataProvider()
        console.log("provider - > ", this)

        console.log(storeS.savedTokenAndCompany)
        // Дефолтні дані
        if(storeS.savedTokenAndCompany.indexOf('token=') != -1) {
            [this.token, this.companyId] = 
            [storeS.savedTokenAndCompany.split('&companyId=')[0], 
            storeS.savedTokenAndCompany.split('&companyId=')[1]]
        } else {
            [this.token, this.companyId] = 
            [storeS.savedTokenAndCompany.split('&companyId=')[0], 
            storeS.savedTokenAndCompany.split('&companyId=')[1]]
        }
    },
    methods: {
        getUrl(type) {
            let fileName = type === 'invoice' ? 'invoice' : 'note'
            let url = new URL(`https://pdf-inside.mysky.team/${fileName}.php`)
            const params = [
                {
                    name: 'token',
                    value: storeS.savedTokenAndCompany.split('&companyId=')[0]
                },
                {
                    name: 'compId',
                    value: storeS.savedTokenAndCompany.split('&companyId=')[1]
                },
                {
                    name: 'actualNum',
                    value: this.obj.num.id
                },
                {
                    name: 'id',
                    value: this.form.documentId
                },
                {
                    name: 'providerId',
                    value: this.provider.providerId
                },
            ] 
            params.forEach(el => {
                url.searchParams.append(el.name, el.value)
            })

            return url
        },
        printInvoice(){
            const formattedDate = (new Date(this.obj.date)).toLocaleDateString("uk-UA", {
                day: "numeric",
                month: "long",
                year: "numeric"
            });

            axios.get(this.getUrl('invoice'), {
                    responseType: 'blob'
                })
                .then(response => {
                    console.log(response)
                    let fileName = `Рахунок №${this.obj.num.id} від ${formattedDate} року.pdf`;

                    // Створюємо посилання і качаємо
                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(blob);

                    const link = document.createElement('a');
                    link.href = url;
                    link.download = fileName;
                    link.click();

                    window.URL.revokeObjectURL(url);
                })
                .catch(error => {
                    this.$toast.error('Помилка при завантаженні PDF');
                    console.error(error);
                });

        },
        printExpenInv() {
            const formattedDate = (new Date(this.obj.date)).toLocaleDateString("uk-UA", {
                day: "numeric",
                month: "long",
                year: "numeric"
            });

            axios.get(this.getUrl('note'), {
                    responseType: 'blob'
                })
                .then(response => {
                    console.log(response)
                    let fileName = `Видаткова накладна № ${this.obj.num.id} від ${formattedDate} року.pdf`;

                    // Створюємо посилання і качаємо
                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(blob);

                    const link = document.createElement('a');
                    link.href = url;
                    link.download = fileName;
                    link.click();

                    window.URL.revokeObjectURL(url);
                })
                .catch(error => {
                    this.$toast.error('Помилка при завантаженні PDF');
                    console.error(error);
                });
        },
        // Номер рахунку так само, як у шапці картки (легасі ФОП/ТОВ до 2023-11-28)
        invoiceNumber() {
            if (this.form.date >= '2023-11-28') return this.form.num ? this.form.num.id : '';
            const n = this.form.provider == 'TOV' ? this.form.numTOV : this.form.numFOP;
            return n ? n.id : '';
        },
        // "2026-10-01..." -> "01 жовтня 2026" (без new Date, щоб не з'їхало через часовий пояс)
        invoiceDateText() {
            const [y, m, d] = String(this.form.date || '').slice(0, 10).split('-');
            if (!y || !m || !d) return '';
            return `${d.padStart(2, '0')} ${this.getdata(Number(m) - 1)} ${y}`;
        },
        copyEmailText() {
            const text = this.emailText;
            const done = () => this.$toast.success(this.$t('Copied'));
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(text).then(done).catch(() => this.copyFallback(text, done));
            } else {
                this.copyFallback(text, done);
            }
        },
        copyFallback(text, done) {
            const ta = document.createElement('textarea');
            ta.value = text;
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
            done();
        },
        toggleDoc(which) {
            this.openDoc = this.openDoc === which ? null : which;
        },
        docAction(docType, action) {
            this.openDoc = null;
            if (action === 'download') {
                docType === 'invoice' ? this.printInvoice() : this.printExpenInv();
                return;
            }
            // send / signsend — спершу email клієнта (вводиться вручну, ТЗ §11)
            this.eobigMode = action;       // 'send' | 'signsend'
            this.eobigDocType = docType;   // 'invoice' | 'waybill'
            this.eobigEmail = (this.form && this.form.eobig && this.form.eobig.clientEmail) ? this.form.eobig.clientEmail : '';
            this.eobigComment = '';
            this.eobigModalShow = true;
        },
        async submitEobig() {
            const email = (this.eobigEmail || '').trim();
            if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
                this.$toast.error(this.$t('eobigEnterEmail'));
                return;
            }
            this.eobigSending = true;
            try {
                if (this.eobigMode === 'signsend') {
                    const res = await try_SignAndSend(this.form.documentId, { docType: this.eobigDocType, email, comment: this.eobigComment });
                    if (res && res.status === 'done' && res.data && res.data.signUrl) {
                        this.eobigStatusOverride = res.data.status || 'awaiting_sign';
                        this.eobigModalShow = false;
                        this.signUrl = res.data.signUrl;
                        this.signModalShow = true;   // відкриваємо віджет підпису eObig
                    } else {
                        this.$toast.error(this.$t('error') || 'Помилка');
                    }
                } else {
                    const fn = this.eobigDocType === 'waybill' ? try_SendWaybill : try_SendInvoice;
                    const res = await fn(this.form.documentId, { email, comment: this.eobigComment });
                    if (res && res.status === 'done') {
                        this.eobigStatusOverride = (res.data && res.data.status) ? res.data.status : 'sent';
                        this.$toast.success(this.$t('eobigSentToast'));
                        this.eobigModalShow = false;
                    } else {
                        this.$toast.error(this.$t('error') || 'Помилка');
                    }
                }
            } catch (e) {
                console.error('[eobig.submit]', e);
                this.$toast.error(this.$t('eobigErrorToast'));
            } finally {
                this.eobigSending = false;
            }
        },
        closeSignModal() {
            this.signModalShow = false;
            this.signUrl = '';
            this.refreshEobigStatus();
        },
        async refreshEobigStatus() {
            try {
                const providerId = (this.provider && this.provider.providerId) ? this.provider.providerId : (this.form && this.form.providerId);
                const eb = this.form && this.form.eobig ? this.form.eobig : null;
                const docId = eb ? (eb.waybillDocId || eb.invoiceDocId) : null;
                if (!providerId || !docId) return;
                const res = await try_GetDocStatus(providerId, docId);
                if (res && res.status === 'done' && res.data && res.data.eobigStatus) {
                    this.eobigStatusOverride = res.data.eobigStatus;
                }
            } catch (e) { /* тихо */ }
        },
        eobigBadge() {
            const st = this.eobigStatusOverride || (this.form && this.form.eobig ? this.form.eobig.status : null);
            if (!st || st === 'none') return null;
            return eobigStatusHelpers.mapEobigStatus(st);
        },
        checkButtonVisible() {
            // Перевірка статусу форми та дозволу користувача на редагування
            return (this.form.payment.status === "pendingpay") || (this.form.payment.status!== "pendingpay" && this.perms[2000] === true);
        },
        closeConfirmBlock(){
            this.showConfirmBox = false;
            this.updateCard();
            this.$emit('getdata')
        },
        getData(){
            this.form = this.obj;
            var textitem = 'Поповнення балансу за номером акаунту - ' + this.obj.sellerPhone + " для користування програмою обліку SkyService POS ( Оренда ПЗ )" 
            for(var item in this.form.products){
                if(this.form.products[item].nomenclatureId == 211){
                    this.form.products[item].nomenclatureName = textitem;
                }
            }
        },
        closeModal(){
            this.$emit('close');
        },
        prevOpen(){
            this.$emit('close');
            this.$emit('prevOpen', this.form.documentId)
        },
        nextOpen(){
            this.$emit('close');
            this.$emit('nextOpen', this.form.documentId)
        },
        remove: function(e){
            this.form.status = "Removed"
            this.$emit("remove", e, this.form);
        },
        open(e){
            this.info_report = e;
            this.showModalReport = true
        },
        // toDone(){
        //     apiServe.confirmSale(this.form.documentId).then(result =>{
        //         if(result.status == 'done'){
        //             this.$toast.success(this.$t('alertChanged'));
        //             this.eventBus.emit('saveINV', true)
        //             this.$emit('close')
        //         } else if(result.status == 'error'){
        //             this.$toast.error(this.$t('saleHasAlreadyBeenConfirmed'));
        //         }
        //     })
        // },
        // toAnnul(){
        //     apiServe.cancelSale(this.form.documentId).then(result =>{
        //         if(result.status == 'done'){
        //             // this.$toast.success(this.$t('alertChanged'));
        //             this.eventBus.emit('saveINV', true)
        //             this.$emit('close')
        //         } else {
        //             this.$toast.error(this.$t('error'));
        //         }
        //     })
        // },
        toCopy(e){
            e.status = 'pendingpay'
            e.created_date_time = this.currentDate()
            e.id = Math.floor(Math.random() * (9999 - 10)) + 10;
            var date = new Date();
            e.num = date.getFullYear()+"_"+ e.id;
            ("e >> ", e)
            apiServe.addSale(e).then(res => {
                if(res){
                    this.$toast.success(this.$t('Copy'));
                    this.$emit('close')
                    this.eventBus.emit('saveINV', true)
                }
            })
        },
        mutatestatus(e){
            return mutateStatusInv(e)
        },
        statusprintInv(){
            this.printInv = true
        },
        // Завантажити рахунок
        downloadInvoice() {
            // Сам запит для отримання pdf
            if(this.obj.documentId) {
                const fetchData = async () => {
                    try{   
                        // Запит на апі, передача параметрів
                        const response = await axios.get("https://pyinside.mysky.team/generateInvoice", {
                            params: {
                                invoiceId: this.obj.documentId,
                                companyId: this.companyId,
                                token: this.token, 
                                provider: JSON.stringify(this.provider)
                            },
                            responseType: 'blob' // обробка файлу
                        });

                        // Робимо потрібну дату
                        const formattedDate = (new Date(this.obj.date)).toLocaleDateString("uk-UA", {
                            day: "numeric",
                            month: "long",
                            year: "numeric"
                        });

                        // Створюємо URL для файлу
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `Рахунок № ${this.obj.num.id} від ${formattedDate} року.pdf`); // Вказуємо ім'я файлу
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } catch (error) {
                        console.error("Помилка при завантаженні файлу:", error);
                    }
                };

                fetchData() // виклик функції
            }
        },
        toDate(){
            var newFullDate = new Date(this.form.datetime);
            var newYear = newFullDate.getFullYear();
            var newMonth = newFullDate.getMonth();
            var newDate = newFullDate.getDate();
            var result = "від " + newDate + " " + this.getdata(newMonth) + " " + newYear + " року";
            return result
        },
        getdata(m){
            var arr=[
                'січня',
                'лютого',
                'березня',
                'квітня',
                'травня',
                'червня',
                'липня',
                'серпня',
                'вересня',
                'жовтня',
                'листопада',
                'грудня',
            ];
            return arr[m]
        },
        getDataProvider(){
            this.$nextTick(() => {
                this.providers.forEach(element => {
                    if (element.providerId == this.form.providerId) {
                        this.provider = element
                        console.log(this.provider)
                    }
                });
            });
        },
        exportToPDFNew() {
            const content = this.$refs.testHtml;
            const content1 = this.$refs.contentToExport;
            const prtHtml = document.getElementById('print');
            console.log('content', prtHtml);
            console.log('content1', content1);
            // const content = document.getElementById('print').innerHTML;
            // Створюємо новий об'єкт jsPDF
            const doc = new jsPDF();

            // Отримуємо HTML-елемент для експорту
            // const content = this.$refs.testHtml;
            // doc.addFont("~@/assets/fonts/hkgrotesk-regular.woff", "hkgrotesk", "regular");
            // doc.setFont("hkgrotesk");
            // Додаємо HTML-вміст до документа
            doc.html(prtHtml, {
                callback: function (doc) {
                        
                    // Зберігаємо PDF-файл з іменем 'invoice.pdf'
                    doc.save('invoice.pdf');
                },
            });
        },
        updateCard(){
            // Використовується для оновлення картки рахунку

            apiServe.getInv(this.form.documentId).then(result => {
                if(result.status == 'done'){
                    this.form = result.data
                    this.componentKey += 1
                } else {
                    this.$toast.error(this.$t('error'));
                }
            })
        },
    },
    mounted() {
        // this.eventBus.on('saveReport', (status) => {
        //     if(status == true) {
        //         this.getReports();
        //     }
        // })
        // this.eventBus.off('updateInvoice');
        // this.eventBus.on('updateInvoice', (status) => {
        //     if(status == true) {
        //         this.updateCard();
        //     }
        // })
    },
    computed:{
        // Текст листа клієнту з підставленими даними рахунку
        emailText() {
            const phone = this.form.sellerPhone || '';
            const name = this.form.sellerName || '';
            // компанія з поля «Компанія» при створенні рахунку; у старих рахунках її нема — беремо ім'я покупця
            const company = this.form.companyName || name;
            return `Вітаємо. Надсилаємо вам рахунок за номером облікового запису ${phone}. `
                + `Найменування компанії ${company}, для користування програмою обліку Skyservice POS. ${name}. `
                + `Попереджаємо про те, якщо ваш тариф зміниться то знижка анулюється а кошти на 12 місяців перерахуються помісячно. `
                + `Після сплати повідомте будь ласка у відповідь на цей лист. Рахунок дійсний 1 добу. `
                + `При оплаті рахунку в Призначенні платежу, вкажіть будь ласка "Рахунок №${this.invoiceNumber()} від ${this.invoiceDateText()} року"`;
        },
        perms(){
            return storeS.perms
        },
        user(){
            return storeS.userbase
        },
        settingInv(){
            return storeS.invoice
        },
        currencyShop(){
            return storeS.currencyShop
        },
        providers() {
            return storeS.providers
        }
    }
}
</script>

<style>
@media print {
  body {
    margin: 0;
    color: #000;
  }

  img {
    max-width: 100%;
  }
}
</style>
